module.exports = __webpack_public_path__ + "static/media/9 Cat's Paw Grip (Pocket Grip).fef0b0b2.jpg";